import { isEqual } from "date-fns";
import { ZOOM_MODE_MONTH, ZOOM_MODE_YEAR, ZOOM_MODE_WEEK, ZOOM_MODE_DAY } from "./Const";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const areListsEqual = (newArgs: any[], lastArgs: any[]): boolean => {
  let equal;
  for (let i = 0; i < newArgs.length; i++) {
    if (newArgs[i] instanceof Date) {
      equal = isEqual(newArgs[i], lastArgs[i]);
    } else if (newArgs[i] instanceof Array) {
      equal = newArgs[i].length === lastArgs[i].length && newArgs[i].every((value, index) => value === lastArgs[i][index]);
    } else {
      equal = newArgs[i] === lastArgs[i];
    }
    if (!equal) {
      return false;
    }
  }
  return true;
};

export const snapMouseMoveBasedOnZoomMode = (mouseMove: number, zoomMode: string, hourWidth: number): number => {
  let snapAmount;
  if (zoomMode === ZOOM_MODE_YEAR || zoomMode === ZOOM_MODE_MONTH || zoomMode === ZOOM_MODE_WEEK) {
    snapAmount = hourWidth * 24;
  } else if (zoomMode === ZOOM_MODE_DAY) {
    snapAmount = hourWidth;
  }
  return Math.round(mouseMove / snapAmount) * snapAmount;
};
